import type { Components, Theme } from "@mui/material/styles";
import { MuiAlert } from "./MuiAlert";
import { MuiAlertTitle } from "./MuiAlertTitle";
import { MuiAutocomplete } from "./MuiAutocomplete";
import { MuiButton } from "./MuiButton";
import { MuiCheckbox } from "./MuiCheckbox";
import { MuiChip } from "./MuiChip";
import { MuiFormControlLabel } from "./MuiFormControlLabel";
import { MuiIconButton } from "./MuiIconButton";
import { MuiLinearProgress } from "./MuiLinearProgress";
import { MuiLink } from "./MuiLink";
import { MuiMenuItem } from "./MuiMenuItem";
import { MuiOutlinedInput } from "./MuiOutlinedInput";
import { MuiPickersCalendarHeader } from "./MuiPickersCalendarHeader";
import { MuiPickersDay } from "./MuiPickersDay";
import { MuiPickersOutlinedInput } from "./MuiPickersOutlinedInput";
import { MuiPickersTextField } from "./MuiPickersTextField";
import { MuiRadio } from "./MuiRadio";
import { MuiSelect } from "./MuiSelect";
import { MuiStack } from "./MuiStack";
import { MuiStep } from "./MuiStep";
import { MuiStepConnector } from "./MuiStepConnector";
import { MuiStepLabel } from "./MuiStepLabel";
import { MuiTextField } from "./MuiTextField";

export const componentOverrides: Components<Omit<Theme, "components">> = {
  MuiAlert,
  MuiAlertTitle,
  MuiAutocomplete,
  MuiButton,
  MuiCheckbox,
  MuiChip,
  MuiFormControlLabel,
  MuiIconButton,
  MuiLinearProgress,
  MuiLink,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPickersCalendarHeader,
  MuiPickersDay,
  MuiPickersOutlinedInput,
  MuiPickersTextField,
  MuiRadio,
  MuiSelect,
  MuiStack,
  MuiStep,
  MuiStepConnector,
  MuiStepLabel,
  MuiTextField,
};
